__turbopack_context__.v({
  "count": "Count-module-scss-module__cENIiq__count",
  "fade-in": "Count-module-scss-module__cENIiq__fade-in",
  "no-transform": "Count-module-scss-module__cENIiq__no-transform",
  "rotate": "Count-module-scss-module__cENIiq__rotate",
});
